export default "__VITE_ASSET__334440bc__"